import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
	signal,
} from '@angular/core';
import { ClassificationType } from '@app/pages/cmms/interfaces/classification.interfaces';
import { CLASSIFICATIONS_TYPES } from '@app/pages/cmms/components/shared-form-group-controls/cmms-classification/classification-types';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { NgxTolgeeModule } from '@tolgee/ngx';

const DEFAULT_CLASSIFICATION: ClassificationType = 'BCT';

@Component({
	selector: 'classification-types-menu',
	templateUrl: './classification-types-menu.component.html',
	styleUrls: ['./classification-types-menu.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, NgxTolgeeModule],
})
export class ClassificationTypesMenuComponent {
	@Output() classificationTypeChanged = new EventEmitter<ClassificationType>();
	@Input() selectedClassification: ClassificationType = DEFAULT_CLASSIFICATION;
	givenName = signal(extract_name(DEFAULT_CLASSIFICATION));

	classificationTypeSelected(event: ClassificationType) {
		this.givenName.set(extract_name(event));
		this.selectedClassification = event;
		this.classificationTypeChanged.emit(this.selectedClassification);
	}
}

function extract_name(classification_type: ClassificationType): string {
	return CLASSIFICATIONS_TYPES.find(row => row['type'] === classification_type)['name'];
}
